import { Routes, Route, Link, Navigate } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Typography,
  Container,
  Box,
  Button,
  CircularProgress,
} from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import HomePage from "./pages/HomePage";
import JobStatusPage from "./pages/JobStatusPage";
import LoginPage from "./pages/LoginPage";
import { useAuth } from "./contexts/AuthContext";

export default function App() {
  const { authenticated, loading, logout } = useAuth();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  if (loading) {
    return (
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress size={20} thickness={5} />
      </Box>
    );
  }

  if (!authenticated) {
    return (
      <Routes>
        <Route path="*" element={<LoginPage />} />
      </Routes>
    );
  }

  return (
    <Box sx={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <AppBar position="sticky">
        <Toolbar sx={{ minHeight: { xs: 56, md: 56 }, px: { xs: 2, md: 3 } }}>
          <Typography
            component={Link}
            to="/"
            sx={{
              color: "inherit",
              textDecoration: "none",
              fontWeight: 600,
              fontSize: 15,
              letterSpacing: "-0.01em",
              flexGrow: 1,
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            <Box
              component="span"
              sx={{
                display: "inline-block",
                width: 8,
                height: 8,
                bgcolor: "primary.main",
                borderRadius: "50%",
              }}
            />
            OCR Studio
          </Typography>

          <Button
            size="small"
            onClick={logout}
            startIcon={!isMobile && <LogoutIcon sx={{ fontSize: 16 }} />}
            sx={{
              color: "text.secondary",
              fontSize: 13,
              minWidth: { xs: 36, sm: "auto" },
              px: { xs: 1, sm: 1.5 },
              "&:hover": { color: "text.primary" },
            }}
          >
            {isMobile ? <LogoutIcon sx={{ fontSize: 16 }} /> : "サインアウト"}
          </Button>
        </Toolbar>
      </AppBar>

      <Container
        maxWidth="md"
        sx={{
          py: { xs: 2.5, md: 6 },
          flex: 1,
          px: { xs: 1.5, sm: 2, md: 3 },
        }}
      >
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/jobs/:jobId" element={<JobStatusPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Container>
    </Box>
  );
}
